import { render, staticRenderFns } from "./tabletwo.vue?vue&type=template&id=f85a4e06&scoped=true&"
import script from "./tabletwo.vue?vue&type=script&lang=js&"
export * from "./tabletwo.vue?vue&type=script&lang=js&"
import style0 from "./tabletwo.vue?vue&type=style&index=0&id=f85a4e06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a4e06",
  null
  
)

export default component.exports